





















import Vue from 'vue';
import HubIcon from './HubIcon.vue';

export default Vue.extend({
  name: 'HubHeading',
  components: {
    HubIcon,
  },
  props: {
    alignRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    spaced: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    close: {
      type: Boolean,
      required: false,
      default: false,
    },
    vcenter: {
      type: Boolean,
      required: false,
      default: true,
    },
    breakOnMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    style(): string {
      let align: string;
      if (
        this.alignRight
        || (
          this.close
          && !this.$slots.default
          && !this.title)
      ) {
        align = 'flex-end';
      } else if (
        this.spaced
        || (this.close && (!!this.$slots.default || this.title))) {
        align = 'space-between';
      } else {
        align = 'flex-start';
      }

      return `
        justify-content: ${this.mobile ? '' : align};
        align-items: ${this.vcenter && !this.mobile && 'center'};
      `;
    },
    mobile(): boolean {
      return this.breakOnMobile && this.$vuetify.breakpoint.mobile;
    },
  },
});
